import { SendToClipboardParams } from 'ag-grid-community';
import { GroupedOption } from 'src/components/atoms/Select/Select';

// Custom handling of copying to clipboard to avoid copying the group header, since they are later pasted as values into other cells.
export const formatAndSendToClipboard = (params: SendToClipboardParams) => {
    // The data string contains all cell values (including group headers) with '\r\n' as the delimiter
    const lines: string[] = params.data.split('\r\n');

    // Filter out lines that are group headers, identified by the value '"\\"\\""'
    const cleanedLines = lines.filter((line) => line !== '"\\"\\""');

    const cleanedData = cleanedLines.join('\r\n');
    navigator.clipboard.writeText(cleanedData);
};

export const generateSelectOptions = (
    items: Array<{ id: number | string; name: string }> | undefined,
    noOptionsMessage: string
): GroupedOption[] => {
    if (!items?.length) {
        return [
            {
                display: noOptionsMessage,
                isHeader: true,
                value: '-1',
            },
        ];
    }

    return items.map((item) => ({
        display: item.name,
        isHeader: false,
        value: item.id.toString(),
    }));
};
